import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BrowserMultiFormatReader } from '@zxing/library/esm/browser';
import './barcodeReader.css';
import Modal from 'react-bootstrap/Modal';
import { t } from './../i18n'
import useApp from '../AppContext';

function BarcodeReader(props) {
    const app = useApp();
    const language = app.sessionToken?.Language;
    const { onScan, onClose } = props;

    const [codeReader] = useState(() => new BrowserMultiFormatReader());
    const [isActive, setIsActive] = useState(false);
    const [deviceList, setDeviceList] = useState([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState(null);

    const videoRef = useRef(null);
    const mountedRef = useRef(false);
    const startingRef = useRef(false);

    const stop = useCallback(async () => {
        try {
            codeReader.reset();
        } catch (e) {
            // ignore
        }
        setIsActive(false);
        startingRef.current = false;

        if (onClose) {
            try { onClose(); } catch (e) { }
        }
        return Promise.resolve();
    }, [codeReader, onClose]);

    const start = useCallback(async () => {
        if (startingRef.current || isActive) return;
        startingRef.current = true;

        let deviceToUse = selectedDeviceId;
        try {
            if (!deviceToUse) {
                const videoInputDevices = await codeReader.listVideoInputDevices();
                setDeviceList(videoInputDevices || []);
                if (videoInputDevices && videoInputDevices.length) {
                    const last = videoInputDevices[videoInputDevices.length - 1];
                    deviceToUse = last.deviceId;
                    setSelectedDeviceId(last.deviceId);
                } else {
                    console.warn('BarcodeReader: No camera devices found');
                    startingRef.current = false;
                    return;
                }
            }

            setIsActive(true);

            await codeReader.decodeFromVideoDevice(deviceToUse, videoRef.current || 'video', (result, err) => {
                if (result) {
                    if (onScan) onScan(result.text);
                    stop();
                }
            });
        } catch (err) {
            console.warn('BarcodeReader start error:', err);
            try { codeReader.reset(); } catch (e) { }
            setIsActive(false);
        } finally {
            startingRef.current = false;
        }
    }, [codeReader, selectedDeviceId, isActive, onScan, stop]);

    function handleChange(event) {
        const id = event.target.value;
        setSelectedDeviceId(id);
        stop().then(() => start()).catch(() => start());
    }

    useEffect(() => {
        if (mountedRef.current) return;
        mountedRef.current = true;
        start().catch(() => { });

        return () => {
            mountedRef.current = false;
            try { codeReader.reset(); } catch (e) { }
        };
    }, [start, codeReader]);

    const SelectedDevice = (
        <select
            className="camera-select"
            value={selectedDeviceId || ''}
            onChange={handleChange}
        >
            {deviceList.map((device, idx) =>
                <option key={idx} value={device.deviceId}>{device.label || `Camera ${idx + 1}`}</option>
            )}
        </select>
    );

    return (
        <Modal
            show={isActive}
            onHide={stop}
            backdrop="static"
            keyboard={false}
            dialogClassName="modal-class"
            size="md"
        >
            <Modal.Header closeButton>
                {t("entryWithBooking.scanQrButton", language)}
            </Modal.Header>
            <Modal.Body className='barcode-modal-body'>
                <video className="video-preview" id="video" ref={videoRef} autoPlay muted playsInline />
                {SelectedDevice}
            </Modal.Body>
        </Modal>
    );
}
export default BarcodeReader;

/*************
license for zxing library


MIT License

 Copyright (c) 2018 ZXing for JS

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

 *************/